module.exports = __webpack_public_path__ + "img/logo2.75b8eff1.png";